import React from 'react';
import { useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

export interface AddVendorPayload {
  vendorId: string;
  vendorName: string;
  accountsCount: number;
}

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>;
  onAdd: (vendor: AddVendorPayload) => void;
}

const VendorActionsRenderer: React.FC<Props> = ({ data, onAdd }) => {
  const { formatMessage } = useIntl();
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<AddIcon />}
      onClick={() =>
        onAdd({
          vendorId: data.vendorId,
          vendorName: data.vendorDisplayName,
          accountsCount: data.beneficiaries?.length ?? 0,
        })
      }
    >
      {formatMessage({ id: 'button.add', defaultMessage: 'Add' })}
    </Button>
  );
};

export default VendorActionsRenderer;
